import React from "react";
import Bootstraphome from "./bootsraphome";

const Home = () => {
  return (
    <div className="w-full min-h-screen pt-16">
      <Bootstraphome />
    </div>
  );
};

export default Home;